<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="10%")
          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
        th(width="10%")
          span(:title="$t('ui.promo_id')") {{ $t('ui.promo_id') }}
        th.text-right(width="13%")
          span(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
        th.text-right(width="13%")
          span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
        th.text-right(width="20%")
          span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
        th.text-right(width="20%")
          span(:title="$t('ui.provider_list')") {{ $t('ui.provider_list') }}
        th.text-right(width="13%")
          span(:title="$t('ui.claim_date')") {{ $t('ui.claim_date') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="8").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="item.member_id") {{ item.member_id }}
        td
          span(:title="item.promotion_id") {{ item.promotion_id }}
        td.text-right
          span.font-weight-bold(:title="$n(item.deposit_amount, 'currency')" :class="$helpers.fontClassName(item.deposit_amount)") {{ $n(item.deposit_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
        td.text-right
          span(:title="item.remark") {{ item.remark }}
        td.text-right
          span(:title="item.provider_list") {{ item.provider_list }}
        td.text-right
          span(:title="$moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss') }}
      tr.footer
        td.text-right(colspan="3")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmountDetail)" :title="$n(subTotalDepositAmountDetail, 'currency')") {{ $n(subTotalDepositAmountDetail, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmountDetail)" :title="$n(subTotalBonusAmountDetail, 'currency')") {{ $n(subTotalBonusAmountDetail, 'currency') }}
      tr.footer
        td.text-right(colspan="3")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmountDetail)" :title="$n(grandTotalDepositAmountDetail, 'currency')") {{ $n(grandTotalDepositAmountDetail, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmountDetail)" :title="$n(grandTotalBonusAmountDetail, 'currency')") {{ $n(grandTotalBonusAmountDetail, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalDepositAmountDetail: 0,
    grandTotalDepositAmountDetail: 0,
    subTotalBonusAmountDetail: 0,
    grandTotalBonusAmountDetail: 0,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalDepositAmountDetail = 0
      this.grandTotalDepositAmountDetail = 0
      this.subTotalBonusAmountDetail = 0
      this.grandTotalBonusAmountDetail = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalDepositAmountDetail = parseFloat(this.subTotalDepositAmountDetail) + parseFloat(value["deposit_amount"]);
          this.subTotalBonusAmountDetail = parseFloat(this.subTotalBonusAmountDetail) + parseFloat(value["bonus_amount"]);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalDepositAmountDetail = totalTbl[0]["deposit_amount"];
          this.grandTotalBonusAmountDetail = totalTbl[0]["bonus_amount"];
        }
      }
    }
  }
};
</script>
